
var Model = require("../types/Model");
var xtend = require("xtend");

module.exports = Model({
	name: "managedresourceslist",
	init: init,
	uninit: uninit,
	listeners: listeners,

	trackEvents: trackEvents,
	pushResources: pushResources
});

function init(){
	this._who = null;
	this._resources = null;
	this._group = null;
	this._managegroup = null;
	this._resources_tracker = this.dispatcher.createTracker();
	this.push({});
}

function uninit(){
	this._resources_tracker.off();
	this._resources_tracker = null;
}

function listeners(){
	return {
		"managedaccount:updated": handle_account_updated,
		"managedresources:open": handle_resources_opened,
		"managedresources:loaded": handle_resources_opened,
		"managedusergroup:updated": handle_orggroup_update
	};
}

function handle_account_updated(data){
	if(!data.open) {
		this._who = null;
		this._managegroup = null;
	} else {
		const who = data.data._id;
		const managegroup = data.group;

		this._who = who;
		this._managegroup = managegroup;
	}
}

function handle_resources_opened(){
	var who = this._who;
	var managegroup = this._managegroup;
	if(!who) return;
	this.api.manage.resources.all(who, managegroup)
		.then(setResources.bind(this));
}

function setResources(list){
	this.pushResources(list);
	this.trackEvents();
}

function pushResources(list){
	this._resources = list;
	this.push(makeMap(list));
}

function trackEvents(){
	var tracker = this._resources_tracker;
	var group = this._group;

	tracker.off();
	tracker.on("mqtt:orggroup/" + group + "/resource/created", handle_resource_created.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/resource/updated", handle_resource_updated.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/resource/removed", handle_resource_removed.bind(this));
}

function handle_orggroup_update(group){
	this._group = group;
}

function handle_resource_created(data){
	var current = this._resources;
	var newResources = current.concat(data);
	this.pushResources(newResources);
}

function handle_resource_updated(data){
	var current = this._resources;
	var id = data.resource;

	var newResources = current.map(function(resource){
		if(resource._id === id)
			return xtend(resource, data);
		return resource;
	});

	this.pushResources(newResources);
}

function handle_resource_removed(data){
	var current = this._resources;
	var id = data.resource;

	var newResources = current.filter(function(resource){
		return resource._id !== id;
	});

	this.pushResources(newResources);
}

function makeMap(array){
	return array.reduce(function(acc, element){
		acc[element._id] = element;
		return acc;
	}, {});
}
